// Регистрация панелей раздела «Найм» в каркасе. Побочный эффект при загрузке модуля: раздел
// объявляет, что умеет рисовать в стопке панелей, а каркас (PanelStack) остаётся без знания о
// разделах. Импортируется из HiringSection — то есть ровно тогда, когда раздел попадает в
// сборку экрана.
//
// Все тринадцать — панели, а не модалки, и это не случайность: заведение кандидата, записи,
// заметки, метки, вакансии, доступов и формулировки ОБРАТИМО (правило 4). Модалка в разделе
// оставлена трём действиям, у которых обратной кнопки нет: уничтожению записи чёрного списка,
// переводу кандидата в сотрудники и склейке двух карточек в одну. Они живут рядом со своим
// объектом, а не здесь.

import { registerPanel } from '@/layout/panel-registry';

import {
  PANEL_ASSISTANT_SETTINGS,
  PANEL_BULK_EDIT,
  PANEL_CANDIDATE_NOTE,
  PANEL_CANDIDATE_STATUS,
  PANEL_CANDIDATE_TAGS,
  PANEL_CREDENTIALS,
  PANEL_DRAFT_DECISION,
  PANEL_ENTRY_LIFT,
  PANEL_NEW_ACCOUNT,
  PANEL_NEW_CANDIDATE,
  PANEL_NEW_ENTRY,
  PANEL_NEW_IMPORT,
  PANEL_NEW_PHRASE,
  PANEL_NEW_VACANCY,
} from '../route';

import { AssistantSettingsPanel } from './AssistantSettingsPanel';
import { BulkEditPanel } from './BulkEditPanel';
import { CandidateStatusPanel } from './CandidateStatusPanel';
import { CredentialsPanel } from './CredentialsPanel';
import { DraftDecisionPanel } from './DraftDecisionPanel';
import { LiftEntryPanel } from './LiftEntryPanel';
import { NewAccountPanel } from './NewAccountPanel';
import { NewCandidatePanel } from './NewCandidatePanel';
import { NewEntryPanel } from './NewEntryPanel';
import { NewImportPanel } from './NewImportPanel';
import { NewPhrasePanel } from './NewPhrasePanel';
import { NewVacancyPanel } from './NewVacancyPanel';
import { NotePanel } from './NotePanel';
import { TagsPanel } from './TagsPanel';

registerPanel(PANEL_NEW_CANDIDATE, {
  title: () => 'Новый кандидат',
  render: ({ onClose }) => <NewCandidatePanel onClose={onClose} />,
});

registerPanel(PANEL_CANDIDATE_STATUS, {
  title: () => 'Смена этапа воронки',
  render: ({ id, onClose }) => <CandidateStatusPanel candidateId={id} onClose={onClose} />,
});

registerPanel(PANEL_CANDIDATE_NOTE, {
  title: () => 'Заметка о кандидате',
  render: ({ id, onClose }) => <NotePanel candidateId={id} onClose={onClose} />,
});

registerPanel(PANEL_CANDIDATE_TAGS, {
  title: () => 'Метки на карточке',
  render: ({ id, onClose }) => <TagsPanel candidateId={id} onClose={onClose} />,
});

registerPanel(PANEL_NEW_ENTRY, {
  title: () => 'Внесение в чёрный список',
  render: ({ id, onClose }) => <NewEntryPanel candidateId={id} onClose={onClose} />,
});

registerPanel(PANEL_ENTRY_LIFT, {
  title: () => 'Снятие записи',
  render: ({ id, onClose }) => <LiftEntryPanel entryId={id} onClose={onClose} />,
});

registerPanel(PANEL_DRAFT_DECISION, {
  title: () => 'Решение по предложению',
  render: ({ id, onClose }) => <DraftDecisionPanel draftId={id} onClose={onClose} />,
});

registerPanel(PANEL_NEW_IMPORT, {
  title: () => 'Выгрузка из мессенджера',
  render: ({ onClose }) => <NewImportPanel onClose={onClose} />,
});

registerPanel(PANEL_NEW_ACCOUNT, {
  title: () => 'Новая учётная запись площадки',
  render: ({ onClose }) => <NewAccountPanel onClose={onClose} />,
});

registerPanel(PANEL_CREDENTIALS, {
  title: () => 'Доступы площадки',
  render: ({ id, onClose }) => <CredentialsPanel accountId={id} onClose={onClose} />,
});

registerPanel(PANEL_NEW_VACANCY, {
  title: () => 'Черновик вакансии',
  render: ({ id, onClose }) => <NewVacancyPanel accountId={id} onClose={onClose} />,
});

registerPanel(PANEL_ASSISTANT_SETTINGS, {
  title: () => 'Режим помощника',
  render: ({ id, onClose }) => <AssistantSettingsPanel accountId={id} onClose={onClose} />,
});

registerPanel(PANEL_NEW_PHRASE, {
  title: () => 'Новая формулировка',
  render: ({ id, onClose }) => <NewPhrasePanel stepCode={id} onClose={onClose} />,
});

registerPanel(PANEL_BULK_EDIT, {
  title: () => 'Изменить у всех',
  render: ({ id, onClose }) =>
    id === undefined ? null : <BulkEditPanel accountId={id} onClose={onClose} />,
});
